import { render, staticRenderFns } from "./forceMajeure.vue?vue&type=template&id=6cbcf53a"
import script from "./forceMajeure.vue?vue&type=script&lang=js"
export * from "./forceMajeure.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QImg,QChip,QSeparator,QCardActions,QPagination,QDialog,QFile,QList,QItem,QItemSection,QBadge,QIcon,QToggle,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QSelect,QInput,QBtn,QTooltip,QImg,QChip,QSeparator,QCardActions,QPagination,QDialog,QFile,QList,QItem,QItemSection,QBadge,QIcon,QToggle})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
